import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  avatardetails: [],
  chatmessage: [],
  agentmiclanguage: "en",
  libraryquestion: "",
  chat_session_id: "",
  temp_chat_session_id: "",
  pinnedstatus: false,
  offerstatus: "",
  agentname: "Agent Hub",
  remainingcredits: "",
  chatpreloader: false,
  creditstokenstatus: false,
  dashbaorddate: `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${new Date().getDate().toString().padStart(2, "0")}`,
  publicdashdate: `${new Date().getFullYear()}-${(new Date().getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${new Date().getDate().toString().padStart(2, "0")}`,
  username: "",
  userlogo: "",
  bgimage: "",
  companyname: "",
  companyimage: "",
  latestavatar: "",
};
const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    avatarDetails: (state, { payload }) => {
      state.avatardetails = payload;
    },
    setStreamingRecord: (state, { payload }) => {
      const find_id_record = state.chatmessage.find(
        (item) => item.id === payload.id
      );
      if (find_id_record) {
        find_id_record.text = payload.text;
        find_id_record.conversection_id = payload.conversection_id;
        find_id_record.message_list = payload.message_list;
      }
    },
    setChatMessage: (state, { payload }) => {
      state.chatmessage = [...state.chatmessage, payload];
    },
    deleteChatMessage: (state) => {
      state.chatmessage = state.chatmessage.slice(0, -1);
    },
    removeHistoryChatMessage: (state) => {
      state.chatmessage = [];
    },
    setLibraryQuestion: (state, { payload }) => {
      state.libraryquestion = payload;
    },
    setChatSessionID: (state, { payload }) => {
      state.chat_session_id = payload;
    },
    setTempChatSessionID: (state, { payload }) => {
      state.temp_chat_session_id = payload;
    },
    setPinnedStatus: (state, { payload }) => {
      state.pinnedstatus = payload;
    },
    setOfferStatus: (state, { payload }) => {
      state.offerstatus = payload;
    },
    setRemaingCredits: (state, { payload }) => {
      state.remainingcredits = payload;
    },
    setChatPreLoader: (state, { payload }) => {
      state.chatpreloader = payload;
    },
    setDashboardDate: (state, { payload }) => {
      state.dashbaorddate = payload;
    },
    setPublicDashDate: (state, { payload }) => {
      state.publicdashdate = payload;
    },
    setCreditsTokenStatus: (state, { payload }) => {
      state.creditstokenstatus = payload;
    },
    setAgentName: (state, { payload }) => {
      state.agentname = payload;
    },
    setAgentMicLanguage: (state, { payload }) => {
      state.agentmiclanguage = payload;
    },
    setUsername: (state, { payload }) => {
      state.username = payload;
    },
    setUserlogo: (state, { payload }) => {
      state.userlogo = payload;
    },
    setCompanylogo: (state, { payload }) => {
      state.companyimage = payload;
    },
    setBackgroundlogo: (state, { payload }) => {
      state.bgimage = payload;
    },
    setCompanyName: (state, { payload }) => {
      state.companyname = payload;
    },
    setLatestavatar: (state, { payload }) => {
      state.latestavatar = payload;
    },
  },
});

export default chatSlice.reducer;
export const {
  avatarDetails,
  setChatMessage,
  deleteChatMessage,
  setLibraryQuestion,
  setChatSessionID,
  setTempChatSessionID,
  removeHistoryChatMessage,
  setPinnedStatus,
  setOfferStatus,
  setChatPreLoader,
  setDashboardDate,
  setPublicDashDate,
  setCreditsTokenStatus,
  setRemaingCredits,
  setAgentName,
  setAgentMicLanguage,
  setUsername,
  setUserlogo,
  setBackgroundlogo,
  setCompanylogo,
  setCompanyName,
  setLatestavatar,
  setStreamingRecord,
} = chatSlice.actions;
